import React from "react";
import styles from "./LocationInfo.module.css";
import LocationModal from "../../../../components/LocationModal/LocationModal";

interface LocationInfoProps {
  location: {
    name?: string;
    lastname?: string;
    address?: string;
    district?: string;
    province?: string;
    department?: string;
    deliveryFeeZone?: { documentId: string; name: string } | null;
  };
  onEditLocation: () => void;
}

const LocationInfo: React.FC<LocationInfoProps> = ({
  location,
  onEditLocation,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleEditLocation = () => {
    setIsModalOpen(true);
    onEditLocation();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const isLocationComplete =
    location.name &&
    location.lastname &&
    location.address &&
    location.district &&
    location.province &&
    location.deliveryFeeZone?.documentId;

  return (
    <div
      className={`${styles.container} ${
        isLocationComplete ? styles.complete : styles.incomplete
      }`}
    >
      <div className={styles.content}>
        {isLocationComplete ? (
          <div className={styles.header}>
            <PackageIcon className={styles.icon} />
            <div className={styles.addressInfo}>
              <span className={styles.addressLabel}>Dirección de envío:</span>
              <span className={styles.addressText}>
                {location.address}, {location.district}, {location.province}
                {location.department ? `, ${location.department}` : ""}
              </span>
            </div>
          </div>
        ) : (
          <div className={styles.placeholder}>
            <WarningIcon className={styles.warningIcon} />
            <div className={styles.warningContent}>
              <span className={styles.promptTitle}>
                Importante: Ingresa tu dirección
              </span>
              <span className={styles.promptText}>
                Es necesario completar tu dirección para calcular costos de
                envío y fechas disponibles.
              </span>
            </div>
          </div>
        )}
      </div>
      <div
        className={`${styles.buttonWrapper} ${
          isLocationComplete ? styles.complete : styles.incomplete
        }`}
      >
        <button
          className={
            isLocationComplete ? "buttonSecondaryOutlined" : "buttonMain"
          }
          onClick={handleEditLocation}
        >
          {isLocationComplete ? "Editar dirección" : "Ingresar dirección"}
        </button>
      </div>
      {isModalOpen && (
        <LocationModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          initialLocation={location}
        />
      )}
    </div>
  );
};

const PackageIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
    className={className}
  >
    <path d="M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z" />
  </svg>
);

const WarningIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
    className={className}
  >
    <path d="M479.788-280q16.212 0 27.5-11.288Q518.576-302.576 518.576-318.788q0-16.212-11.288-27.5Q496-357.576 479.788-357.576q-16.212 0-27.5 11.288Q441-335 441-318.788q0 16.212 11.288 27.5Q463.576-280 479.788-280Zm-38.8-157.424h79.857v-239.857h-79.857v239.857ZM480.268-59.846q-86.27 0-162.544-32.556-76.275-32.555-132.609-88.889-56.335-56.334-88.89-132.583-32.556-76.249-32.556-162.67 0-86.422 32.556-162.896 32.555-76.475 88.89-132.523 56.334-56.049 132.609-88.799Q393.998-892.461 480.268-892.461q86.958 0 163.247 32.75 76.289 32.75 132.338 88.799 56.049 56.048 88.799 132.523Q897.401-561.914 897.401-475.492q0 86.421-32.75 162.67-32.75 76.249-88.799 132.583-56.049 56.334-132.338 88.889-76.289 32.556-163.246 32.556Z" />
  </svg>
);

export default LocationInfo;
